import React, { useEffect, useState, useRef } from "react";
import Header from "../../../Componets/Header";
import { useLocation } from "react-router-dom";
import toast from "react-hot-toast";
import Loadercomponent from "../../../Componets/Loader";
import { get_received_orders_report } from "../../../Controllers/Dashboard/Dashboard";
import ReactToPrint from "react-to-print";
import { Button } from "antd";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import { registerCairoFont } from "../cairo-font";
import ScrollWrapper from "../../../Componets/ScrollWrapper";
import formatDateDDMMYYYY from "../../../Main/formatDate";

const ReceivedOrdersReport = () => {
  let location = useLocation();
  let componentRef = useRef();

  const [loader, setLoader] = useState(false);
  const [body, setBody] = useState([]);

  const headers = {
    name: "Received Orders",
    components: [
      {
        type: "search",
        name: "search",
        placeholder: "Search by order number",
        value: "",
      },
      {
        type: "select",
        name: "sort",
        placeholder: "Sort",
        value: null,
        allowClear: true,
        options: [
          { value: "0", label: "Total Amount (Low to High)" },
          { value: "1", label: "Total Amount (High to Low)" },
        ],
      },
      {
        type: "filter",
        name: "branch",
        allowClear: true,
        showSearch: true,
        filterOption: false,
        placeholder: "Branch",
        className: "w-[200px]",
        api: "get-all-branches",
        value: null,
        options: null,
      },
      {
        type: "filter",
        name: "status",
        placeholder: "Status",
        value: null,
        allowClear: true,
        options: [
          { value: 0, label: "Pending" },
          { value: 1, label: "Received" },
        ],
      },
      {
        type: "range",
        name: "date",
        value: {
          start: "",
          end: "",
        },
      },
    ],
    navigate: {
      tabs: [
        { name: "Reports", path: "/app/reports" },
        { name: "Received Order", path: "" },
      ],
      total: [
        { value: 0, label: "Total" },
        { value: 0, label: "Active" },
        { value: "0", label: "Inactive" },
      ],
    },
  };

  const [header, setHeader] = useState(headers);

  const formdata = (data) => {
    fetchData(data);
  };

  const fetchData = async (tabledata = {}) => {
    try {
      setLoader(true);

      const data = {
        search: tabledata?.search,
        sort: tabledata?.sort,
        branch: tabledata?.branch,
        status: tabledata?.status,
        date: tabledata?.date,
      };

      const res = await get_received_orders_report(data);

      if (res?.status) {
        setBody(res?.data?.reports || []);
        setLoader(false);
      } else {
        toast?.error(res?.message || "Failed to fetch received orders");
        setLoader(false);
      }
    } catch (errors) {
      toast?.error(errors?.message);
      setLoader(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  const downloadCSV = () => {
    try {
      if (!body || body.length === 0) {
        toast.error("No data available to download");
        return;
      }

      const mainHeaders = [
        "Order Number",
        "Date",
        "Due Date",
        "From Branch",
        "To Branch",
        "Ordered Total",
        "Received Total",
        "Difference",
        "Status",
      ];

      const detailHeaders = [
        "S.No",
        "Product",
        "Unit",
        "Ordered Qty",
        "Ordered Price",
        "Ordered Total",
        "Received Qty",
        "Received Price",
        "Received Total",
        "Qty Diff",
        "Total Diff",
      ];

      let csvContent = [mainHeaders.join(",")];

      body.forEach((report, orderIndex) => {
        const mainRow = [
          `#RO-${report?.order?.number || ""}`,
          formatDateDDMMYYYY(report?.order?.date) || "",
          report?.order?.due_date ? formatDateDDMMYYYY(report?.order?.due_date) : "",
          `"${report?.order?.from_branch?.name || ""}"`,
          `"${report?.order?.to_branch?.name || ""}"`,
          report?.summary?.ordered_total?.toFixed(3) || "0.000",
          report?.summary?.received_total?.toFixed(3) || "0.000",
          report?.summary?.total_difference?.toFixed(3) || "0.000",
          report?.order?.received ? "Received" : "Pending",
        ];
        csvContent.push(mainRow.join(","));

        csvContent.push(detailHeaders.join(","));

        report?.details?.forEach((detail, detailIndex) => {
          const detailRow = [
            detailIndex + 1,
            `"${detail?.product_name || "N/A"}"`,
            `"${detail?.unit || "N/A"}"`,
            detail?.ordered_quantity || 0,
            detail?.ordered_price?.toFixed(3) || "0.000",
            detail?.ordered_total?.toFixed(3) || "0.000",
            detail?.received_quantity || 0,
            detail?.received_price?.toFixed(3) || "0.000",
            detail?.received_total?.toFixed(3) || "0.000",
            detail?.quantity_difference || 0,
            detail?.total_difference?.toFixed(3) || "0.000",
          ];
          csvContent.push(detailRow.join(","));
        });

        if (orderIndex < body.length - 1) {
          csvContent.push("");
        }
      });

      const totalOrdered =
        body?.reduce((acc, val) => acc + (val?.summary?.ordered_total || 0), 0)?.toFixed(3) ||
        "0.000";
      const totalReceived =
        body?.reduce((acc, val) => acc + (val?.summary?.received_total || 0), 0)?.toFixed(3) ||
        "0.000";
      const totalDifference =
        body?.reduce((acc, val) => acc + (val?.summary?.total_difference || 0), 0)?.toFixed(3) ||
        "0.000";

      csvContent.push("");
      csvContent.push(
        ["", "", "", "", "GRAND TOTAL", totalOrdered, totalReceived, totalDifference].join(",")
      );

      const csvString = "\uFEFF" + csvContent.join("\n");
      const blob = new Blob([csvString], { type: "text/csv;charset=utf-8;" });
      const link = document.createElement("a");
      const url = URL.createObjectURL(blob);

      link.setAttribute("href", url);
      link.setAttribute(
        "download",
        `Received_Orders_Report_${new Date().toLocaleDateString().replace(/\//g, "_")}.csv`
      );
      link.style.visibility = "hidden";

      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(url);
    } catch (error) {
      console.error("Error generating CSV:", error);
      toast.error("Failed to generate CSV file");
    }
  };

  const downloadPDF = () => {
    try {
      if (!body || body.length === 0) {
        toast.error("No data available to download");
        return;
      }

      const doc = new jsPDF({
        orientation: "landscape",
        unit: "mm",
        format: "a4",
      });

      registerCairoFont(doc);
      const pageWidth = doc.internal.pageSize.getWidth();
      doc.setFont("Cairo-Bold", "bold");

      let startY = 20;

      body.forEach((report, orderIndex) => {
        if (orderIndex > 0) {
          doc.addPage();
          startY = 20;
        }

        doc.setFontSize(16);
        doc.text(
          `Received Order - #RO-${report?.order?.number || ""}`,
          pageWidth / 2,
          startY,
          { align: "center" }
        );

        doc.setFontSize(10);
        doc.text(`From: ${report?.order?.from_branch?.name || ""}`, 14, startY + 8);
        doc.text(`To: ${report?.order?.to_branch?.name || ""}`, 14, startY + 16);
        doc.text(
          `Status: ${report?.order?.received ? "Received" : "Pending"}`,
          14,
          startY + 24
        );

        startY += 35;

        const summaryHeaders = [["Description", "Amount"]];
        const summaryData = [
          ["Ordered Total", report?.summary?.ordered_total?.toFixed(3) || "0.000"],
          ["Received Total", report?.summary?.received_total?.toFixed(3) || "0.000"],
          ["Difference", report?.summary?.total_difference?.toFixed(3) || "0.000"],
        ];

        autoTable(doc, {
          startY,
          head: summaryHeaders,
          body: summaryData,
          theme: "grid",
          styles: {
            font: "Cairo",
            textColor: [0, 0, 0],
            lineColor: [7, 181, 83],
            lineWidth: 0.2,
          },
          headStyles: {
            font: "Cairo",
            fontStyle: "bold",
            fillColor: false,
            lineColor: [7, 181, 83],
            lineWidth: 0.6,
          },
          margin: { left: 14 },
        });

        startY = doc.lastAutoTable.finalY + 15;

        const detailHeaders = [
          "S.No",
          "Product",
          "Unit",
          "Ordered Qty",
          "Ordered Price",
          "Ordered Total",
          "Received Qty",
          "Received Price",
          "Received Total",
          "Qty Diff",
          "Total Diff",
        ];

        const detailRows =
          report?.details?.map((detail, index) => [
            index + 1,
            detail?.product_name || "N/A",
            detail?.unit || "N/A",
            detail?.ordered_quantity || 0,
            detail?.ordered_price?.toFixed(3) || "0.000",
            detail?.ordered_total?.toFixed(3) || "0.000",
            detail?.received_quantity || 0,
            detail?.received_price?.toFixed(3) || "0.000",
            detail?.received_total?.toFixed(3) || "0.000",
            detail?.quantity_difference || 0,
            detail?.total_difference?.toFixed(3) || "0.000",
          ]) || [];

        autoTable(doc, {
          startY,
          head: [detailHeaders],
          body: detailRows,
          theme: "grid",
          margin: { left: 14 },
          styles: {
            font: "Cairo",
            textColor: [0, 0, 0],
            lineColor: [7, 181, 83],
            lineWidth: 0.2,
            fontSize: 7,
            cellPadding: 2,
          },
          headStyles: {
            font: "Cairo",
            fontStyle: "bold",
            fillColor: false,
            lineColor: [7, 181, 83],
            lineWidth: 0.6,
          },
        });

        startY = doc.lastAutoTable.finalY + 10;
      });

      const totalOrdered =
        body?.reduce((acc, val) => acc + (val?.summary?.ordered_total || 0), 0)?.toFixed(3) ||
        "0.000";
      const totalReceived =
        body?.reduce((acc, val) => acc + (val?.summary?.received_total || 0), 0)?.toFixed(3) ||
        "0.000";
      const totalDifference =
        body?.reduce((acc, val) => acc + (val?.summary?.total_difference || 0), 0)?.toFixed(3) ||
        "0.000";

      doc.setFontSize(12);
      doc.text(
        `Grand Totals - Ordered: ${totalOrdered} | Received: ${totalReceived} | Difference: ${totalDifference}`,
        14,
        doc.internal.pageSize.height - 20
      );

      const formattedDate = new Date().toLocaleDateString("en-GB");
      doc.save(`Received_Orders_Report_${formattedDate}.pdf`);
    } catch (error) {
      console.error("Error generating PDF:", error);
      toast.error("Failed to generate PDF file");
    }
  };

  const totalOrdered =
    body?.reduce((acc, val) => acc + (val?.summary?.ordered_total || 0), 0) || 0;
  const totalReceived =
    body?.reduce((acc, val) => acc + (val?.summary?.received_total || 0), 0) || 0;
  const totalDifference =
    body?.reduce((acc, val) => acc + (val?.summary?.total_difference || 0), 0) || 0;

  return (
    <Header headers={header} setHeaders={setHeader} formdata={formdata}>
      <Loadercomponent loader={loader}>
        <div className="mt-4">
          <div className="text-right pb-4 flex gap-3 justify-end">
            <Button
              className="!bg-[#07b553] !border-[#07b553] hover:!bg-[#38cb82] hover:!border-[#38cb82]"
              type="primary"
              onClick={downloadCSV}
            >
              Download CSV
            </Button>

            <ReactToPrint
              trigger={() => (
                <Button
                  className="mr-2 !bg-[#07b553] !border-[#07b553] hover:!bg-[#38cb82] hover:!border-[#38cb82]"
                  type="primary"
                >
                  Download PDF
                </Button>
              )}
              content={() => componentRef}
              pageStyle={`
                @page {
                  size: landscape;
                  margin: 10mm;
                }

                @media print {
                  tfoot {
                    position: static !important;
                    bottom: auto !important;
                  }
                  thead {
                    display: table-header-group !important;
                  }
                  tfoot {
                    display: table-row-group !important;
                  }
                }

                table {
                  border-collapse: collapse;
                  width: 100%;
                }
                th, td {
                  border: 1px solid #ddd;
                  padding: 6px;
                }
                th {
                  background-color: #f4f4f4;
                }
                @media print {
                  table, thead, tbody, tfoot, tr, th, td {
                    border: 1px solid #000 !important;
                    border-collapse: collapse !important;
                  }
                  th {
                    background-color: #f4f4f4 !important;
                    -webkit-print-color-adjust: exact !important;
                    print-color-adjust: exact !important;
                  }
                  table {
                    width: 100% !important;
                    border-collapse: collapse !important;
                  }
                  thead, tfoot {
                    position: static !important;
                  }
                }
              `}
            />
          </div>
        </div>

        <ScrollWrapper>
          <div
            className="max-h-[70vh] overflow-y-auto scrollbar-hide remove-scroll-limit"
            ref={(el) => (componentRef = el)}
          >
            <table className="w-full bg-white border-collapse">
              <thead className="text-gray-500 bg-gray-100 sticky top-0 z-10">
                <tr className="p-2">
                  <th className="border p-2 text-sm font-normal text-left">Order</th>
                  <th className="border p-2 text-sm font-normal text-left">Date</th>
                  <th className="border p-2 text-sm font-normal">Due Date</th>
                  <th className="border p-2 text-sm font-normal">From Branch</th>
                  <th className="border p-2 text-sm font-normal">To Branch</th>
                  <th className="border p-2 text-sm font-normal">Ordered Total</th>
                  <th className="border p-2 text-sm font-normal">Received Total</th>
                  <th className="border p-2 text-sm font-normal">Difference</th>
                  <th className="border p-2 text-sm font-normal">Status</th>
                </tr>
              </thead>
              <tbody>
                {body?.map((report, index) => (
                  <React.Fragment key={index}>
                    <tr className="bg-white">
                      <td className="border p-2 text-sm text-medium text-left">
                        #RO-{report?.order?.number}
                      </td>
                      <td className="border p-2 text-sm text-medium text-left">
                        {formatDateDDMMYYYY(report?.order?.date)}
                      </td>
                      <td className="border p-2 text-sm text-medium text-center">
                        {report?.order?.due_date
                          ? formatDateDDMMYYYY(report?.order?.due_date)
                          : "N/A"}
                      </td>
                      <td className="border p-2 text-sm text-medium text-center">
                        {report?.order?.from_branch?.name || "N/A"}
                      </td>
                      <td className="border p-2 text-sm text-medium text-center">
                        {report?.order?.to_branch?.name || "N/A"}
                      </td>
                      <td className="border p-2 text-sm text-medium text-center">
                        {report?.summary?.ordered_total?.toFixed?.(3)}
                      </td>
                      <td className="border p-2 text-sm text-medium text-center">
                        {report?.summary?.received_total?.toFixed?.(3)}
                      </td>
                      <td
                        className={`border p-2 text-sm text-medium text-center ${report?.summary?.total_difference < 0
                          ? "text-red-600"
                          : report?.summary?.total_difference > 0
                            ? "text-green-600"
                            : ""
                          }`}
                      >
                        {report?.summary?.total_difference?.toFixed?.(3)}
                      </td>
                      <td className="border p-2 text-sm text-medium text-center">
                        {report?.order?.received ? "Received" : "Pending"}
                      </td>
                    </tr>
                    <tr>
                      <td colSpan={9} className="pt-2 pb-2">
                        <table className="w-full border text-gray-500 bg-gray-50">
                          <thead>
                            <tr className="font-normal">
                              <th className="border p-1 text-xs font-normal">S.NO</th>
                              <th className="border p-1 text-xs font-normal">PRODUCT</th>
                              <th className="border p-1 text-xs font-normal">UNIT</th>
                              <th className="border p-1 text-xs font-normal">ORDERED QTY</th>
                              <th className="border p-1 text-xs font-normal">ORDERED PRICE</th>
                              <th className="border p-1 text-xs font-normal">ORDERED TOTAL</th>
                              <th className="border p-1 text-xs font-normal">RECEIVED QTY</th>
                              <th className="border p-1 text-xs font-normal">RECEIVED PRICE</th>
                              <th className="border p-1 text-xs font-normal">RECEIVED TOTAL</th>
                              <th className="border p-1 text-xs font-normal">QTY DIFF</th>
                              <th className="border p-1 text-xs font-normal">TOTAL DIFF</th>
                            </tr>
                          </thead>
                          <tbody className="text-gray-500">
                            {report?.details?.map((d, i) => (
                              <tr key={i} className="text-xs">
                                <td className="border p-1 text-center">{i + 1}</td>
                                <td className="border p-1 text-center">
                                  {d?.product_name || "N/A"}
                                </td>
                                <td className="border p-1 text-center">{d?.unit || "N/A"}</td>
                                <td className="border p-1 text-center">
                                  {d?.ordered_quantity}
                                </td>
                                <td className="border p-1 text-center">
                                  {d?.ordered_price?.toFixed?.(3)}
                                </td>
                                <td className="border p-1 text-center">
                                  {d?.ordered_total?.toFixed?.(3)}
                                </td>
                                <td className="border p-1 text-center">
                                  {d?.received_quantity}
                                </td>
                                <td className="border p-1 text-center">
                                  {d?.received_price?.toFixed?.(3)}
                                </td>
                                <td className="border p-1 text-center">
                                  {d?.received_total?.toFixed?.(3)}
                                </td>
                                <td
                                  className={`border p-1 text-center ${d?.quantity_difference < 0
                                    ? "text-red-600"
                                    : d?.quantity_difference > 0
                                      ? "text-green-600"
                                      : ""
                                    }`}
                                >
                                  {d?.quantity_difference}
                                </td>
                                <td
                                  className={`border p-1 text-center ${d?.total_difference < 0
                                    ? "text-red-600"
                                    : d?.total_difference > 0
                                      ? "text-green-600"
                                      : ""
                                    }`}
                                >
                                  {d?.total_difference?.toFixed?.(3)}
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </td>
                    </tr>
                  </React.Fragment>
                ))}
              </tbody>
              <tfoot className="sticky bottom-0 bg-white z-10">
                <tr className="font-semibold bg-gray-100 text-sm">
                  <td className="border p-2 font-normal text-medium" colSpan={5}>
                    Total
                  </td>
                  <td className="border p-2 font-normal text-medium">
                    {totalOrdered?.toFixed?.(3)}
                  </td>
                  <td className="border p-2 font-normal text-medium">
                    {totalReceived?.toFixed?.(3)}
                  </td>
                  <td
                    className={`border p-2 font-normal text-medium ${totalDifference < 0
                      ? "text-red-600"
                      : totalDifference > 0
                        ? "text-green-600"
                        : ""
                      }`}
                  >
                    {totalDifference?.toFixed?.(3)}
                  </td>
                  <td className="border p-2 font-normal text-medium"></td>
                </tr>
              </tfoot>
            </table>
          </div>
        </ScrollWrapper>
      </Loadercomponent>
    </Header>
  );
};

export default ReceivedOrdersReport;